import { render, staticRenderFns } from "./WelcomeCard.vue?vue&type=template&id=0af13c91&"
import script from "./WelcomeCard.vue?vue&type=script&lang=ts&"
export * from "./WelcomeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports